import { RecommendationsDataInterface } from 'src/components/Providers/RecommendationsProvider';

export const hasQuizRecommendations = (
	recommendationsData: RecommendationsDataInterface
): boolean => {
	return (
		!!recommendationsData &&
		Array.isArray(recommendationsData?.recommendations) &&
		recommendationsData?.recommendations.length > 0
	);
};

export const hasQuizAnswers = (recommendationsData: RecommendationsDataInterface): boolean => {
	return (
		!!recommendationsData &&
		!!recommendationsData?.recommendationQuizResponses &&
		Object.values(recommendationsData?.recommendationQuizResponses)
			.filter(v => v !== 'RecommendationQuizResponses')
			.some(answer => answer !== null)
	);
};
